'use client'

import dynamic from 'next/dynamic'
import type { ComponentProps } from 'react'
import type { CtaShader } from '@/components/effects/CtaShader'

/**
 * The particle field, fetched only once the page it decorates is running.
 *
 * three.js is by far the largest thing this site ships, and nothing on the
 * page depends on it: the field is a background, the headline over it is
 * server-rendered, and a visitor who never gets the chunk sees the same words
 * on the same background colour. Loading it out of band keeps it off the path
 * to the first paint.
 *
 * `ssr: false` for the same reason the component is a client one — it is a
 * canvas, and there is nothing to render on a server.
 */
const Field = dynamic(() => import('@/components/effects/CtaShader').then((module) => module.CtaShader), {
    ssr: false,
})

export function ShaderField(props: ComponentProps<typeof CtaShader>) {
    return <Field {...props} />
}
